(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.autoplayTimer = null;
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.isTransitioning = false;
    }

    connectedCallback() {
      this.slides = this.querySelectorAll('[data-slide-index]');
      this.dots = this.querySelectorAll('[data-dot-index]');
      this.totalSlides = parseInt(this.dataset.activeSlides) || 1;
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = (parseFloat(this.dataset.speed) || 5) * 1000;

      if (this.totalSlides <= 1) return;

      const prevBtn = this.querySelector('[data-prev]');
      const nextBtn = this.querySelector('[data-next]');

      if (prevBtn) prevBtn.addEventListener('click', () => this.prev());
      if (nextBtn) nextBtn.addEventListener('click', () => this.next());

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goToSlide(parseInt(dot.dataset.dotIndex));
        });
      });

      this.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        this.touchEndX = e.changedTouches[0].screenX;
        const diff = this.touchStartX - this.touchEndX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) this.next();
          else this.prev();
        }
      }, { passive: true });

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => { if (this.autoplay) this.startAutoplay(); });

      if (this.autoplay) this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    goToSlide(index) {
      if (index === this.currentIndex || this.isTransitioning) return;
      this.isTransitioning = true;

      const prev = this.slides[this.currentIndex];
      const next = this.slides[index];
      const prevDot = this.dots[this.currentIndex];
      const nextDot = this.dots[index];

      if (prev) {
        prev.classList.remove('hero-slider__slide--active');
        prev.setAttribute('aria-hidden', 'true');
      }
      if (prevDot) {
        prevDot.classList.remove('hero-slider__dot--active');
        prevDot.setAttribute('aria-selected', 'false');
        // Reset animation by cloning the progress circle
        const circle = prevDot.querySelector('.hero-slider__dot-progress');
        if (circle) {
          circle.style.animation = 'none';
          circle.offsetHeight; // reflow
          circle.style.animation = '';
        }
      }

      this.currentIndex = index;

      if (next) {
        next.classList.add('hero-slider__slide--active');
        next.setAttribute('aria-hidden', 'false');
      }
      if (nextDot) {
        nextDot.classList.add('hero-slider__dot--active');
        nextDot.setAttribute('aria-selected', 'true');
      }

      setTimeout(() => { this.isTransitioning = false; }, 700);

      if (this.autoplay) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    next() {
      this.goToSlide((this.currentIndex + 1) % this.totalSlides);
    }

    prev() {
      this.goToSlide((this.currentIndex - 1 + this.totalSlides) % this.totalSlides);
    }

    startAutoplay() {
      if (!this.autoplay || this.totalSlides <= 1) return;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => this.next(), this.speed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('hero-slider')) {
    customElements.define('hero-slider', HeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const CACHE_KEY_PREFIX = 'igfeed_';
    const CACHE_TTL = 15 * 60 * 1000; // 15 minutes

    class InstagramFeed {
      constructor(el) {
        this.el = el;
        this.token = el.dataset.accessToken;
        this.postCount = parseInt(el.dataset.postCount, 10) || 6;
        this.instagramUrl = el.dataset.instagramUrl || 'https://instagram.com';
        this.showArrows = el.dataset.showArrows !== 'false';
        this.columns = parseInt(el.dataset.columns, 10) || 5;
        this.currentIndex = 0;
        this.posts = [];

        this.wrapper = el.querySelector('.instagram-feed-section__wrapper');
        this.track = el.querySelector('.instagram-feed-section__track');
        this.prevBtn = el.querySelector('.instagram-feed-section__arrow--prev');
        this.nextBtn = el.querySelector('.instagram-feed-section__arrow--next');

        if (this.token && this.track) {
          this.loadFeed();
        }
      }

      async loadFeed() {
        try {
          const posts = await this.fetchPosts();
          this.posts = posts;
          this.renderPosts(posts);
          this.initSlider();
        } catch (err) {
          this.showError(err.message);
        }
      }

      async fetchPosts() {
        const cacheKey = CACHE_KEY_PREFIX + btoa(this.token).slice(0, 16);
        const cached = this.getCache(cacheKey);
        if (cached) return cached;

        const fields = 'id,media_type,media_url,thumbnail_url,permalink,timestamp';
        const url = `https://graph.instagram.com/me/media?fields=${fields}&limit=${this.postCount}&access_token=${this.token}`;

        const res = await fetch(url);
        const data = await res.json();

        if (data.error) {
          throw new Error(data.error.message || 'Instagram API error');
        }

        const posts = (data.data || []).filter(p => p.media_type !== 'VIDEO' || p.thumbnail_url);
        this.setCache(cacheKey, posts);
        return posts;
      }

      renderPosts(posts) {
        if (!posts.length) {
          this.showError('No se encontraron publicaciones.');
          return;
        }

        // Remove skeleton items and replace with real content
        this.track.innerHTML = posts.map(post => {
          const imgSrc = post.media_type === 'VIDEO' ? post.thumbnail_url : post.media_url;
          const link = post.permalink || this.instagramUrl;
          const isVideo = post.media_type === 'VIDEO';

          return `
            <div class="instagram-feed-section__item" role="listitem">
              <a
                href="${link}"
                target="_blank"
                rel="noopener noreferrer"
                class="instagram-feed-section__link"
                aria-label="Ver publicación en Instagram"
              >
                <div class="instagram-feed-section__image-wrapper">
                  <img
                    src="${imgSrc}"
                    alt="Instagram post"
                    width="600"
                    height="600"
                    loading="lazy"
                    class="instagram-feed-section__image"
                    crossorigin="anonymous"
                  >
                  <div class="instagram-feed-section__overlay" aria-hidden="true">
                    ${isVideo
                      ? `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="white" stroke="none" aria-hidden="true"><polygon points="5 3 19 12 5 21 5 3"/></svg>`
                      : `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>`
                    }
                  </div>
                </div>
              </a>
            </div>
          `;
        }).join('');
      }

      initSlider() {
        if (!this.showArrows || !this.prevBtn || !this.nextBtn) return;

        this.items = Array.from(this.track.querySelectorAll('.instagram-feed-section__item'));
        this.visibleCount = this.getVisibleCount();

        this.prevBtn.addEventListener('click', () => this.slide(-1));
        this.nextBtn.addEventListener('click', () => this.slide(1));

        const ro = new ResizeObserver(() => {
          this.visibleCount = this.getVisibleCount();
          const max = Math.max(0, this.items.length - this.visibleCount);
          if (this.currentIndex > max) {
            this.currentIndex = max;
            this.applyTranslate();
          }
          this.updateArrows();
        });
        ro.observe(this.track);

        this.updateArrows();
      }

      getVisibleCount() {
        const cols = getComputedStyle(this.track).getPropertyValue('grid-template-columns');
        return cols.trim().split(' ').filter(Boolean).length;
      }

      slide(dir) {
        const max = Math.max(0, this.items.length - this.visibleCount);
        this.currentIndex = Math.min(Math.max(this.currentIndex + dir, 0), max);
        this.applyTranslate();
        this.updateArrows();
      }

      applyTranslate() {
        if (!this.items.length) return;
        const gap = parseInt(getComputedStyle(this.track).gap, 10) || 12;
        const itemW = this.items[0].getBoundingClientRect().width;
        this.track.style.transform = `translateX(-${this.currentIndex * (itemW + gap)}px)`;
      }

      updateArrows() {
        if (!this.prevBtn || !this.nextBtn) return;
        const max = Math.max(0, this.items.length - this.visibleCount);
        this.prevBtn.disabled = this.currentIndex === 0;
        this.nextBtn.disabled = this.currentIndex >= max;
      }

      showError(msg) {
        const feedArea = this.el.querySelector('.instagram-feed-section__feed-area');
        if (feedArea) {
          feedArea.innerHTML = `<div class="instagram-feed-section__error"><p>⚠️ ${msg}</p><p style="font-size:0.8rem;margin-top:4px;">Verifica que el Access Token sea válido y no haya expirado.</p></div>`;
        }
      }

      getCache(key) {
        try {
          const raw = sessionStorage.getItem(key);
          if (!raw) return null;
          const { ts, data } = JSON.parse(raw);
          if (Date.now() - ts > CACHE_TTL) { sessionStorage.removeItem(key); return null; }
          return data;
        } catch { return null; }
      }

      setCache(key, data) {
        try { sessionStorage.setItem(key, JSON.stringify({ ts: Date.now(), data })); } catch {}
      }
    }

    document.querySelectorAll('[data-section-type="instagram-feed"]').forEach(el => new InstagramFeed(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
